import { BigIntish, divideWeiByWei } from "@looksrare/utils";

/**
 * Pyth sends price as BigInt with an exponent to our backend. We get this price from backend
 * with a consistent 1e8 exponent, so we need to divide it by 1e8 to get the actual price as float
 */
export const getPythPriceAsFloat = (price: BigIntish) => {
  return divideWeiByWei(price, 1e8);
};
